import axios from "axios";
import { COURT_RECORD_DATA_FAILED, COURT_RECORD_DATA_LOADING, COURT_RECORD_DATA_SUCCESS, COURT_RECORD_SAVE_DATA_FAILED, COURT_RECORD_SAVE_DATA_LOADING, COURT_RECORD_SAVE_DATA_SUCCESS } from "../Constants/CourtRecordCheckConstants";
import { FOLDERPATH } from "../Constants/config";
import { handleApiError } from "../Helper/actionHelper";


export const getCourtRecordCheckData = (callback=()=>{}) => async (dispatch) => {
    try{
        let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

        dispatch({type : COURT_RECORD_DATA_LOADING});

        const requestData = {
            token: userLocalData?.id
        }

        const headers = {
            "Content-Type": "application/json",
            Username: "ibridge",
            Password: "ibridge@2020",
          };

        const {data} = await axios.post(FOLDERPATH + '/NewSigndriveApi/declarationDetails' , requestData, {headers: headers});
        
        dispatch({
            type : COURT_RECORD_DATA_SUCCESS,
            payload : data
        })
        callback(data);

        handleApiError(data);

    } catch (error) {
        dispatch({
            type: COURT_RECORD_DATA_FAILED,
            payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,  
        })

        handleApiError(error);

    }
}

export const saveCourtRecordCheckData = (payload, callback=()=>{}) => async (dispatch) => {
    try{
        let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

        dispatch({type : COURT_RECORD_SAVE_DATA_LOADING});

        const requestData = {
            token: userLocalData?.id,
            ...payload
        }

        const headers = {
            "Content-Type": "application/json",
            Username: "ibridge",
            Password: "ibridge@2020",
          };

        const {data} = await axios.post(FOLDERPATH + "/NewSigndriveApi/saveDeclarationDetails" , requestData, {headers: headers});
        
        dispatch({
            type : COURT_RECORD_SAVE_DATA_SUCCESS,
            payload : data
        })
        callback(data?.data);

        handleApiError(data);

    } catch (error) {
        dispatch({
            type: COURT_RECORD_SAVE_DATA_FAILED,
            payload:
            error.response && error.response.data.message
              ? error.response
              : error.response,  
        })

        handleApiError(error);

    }
}